/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Choose any concentration unit (M, mM, µM, nM) and volume unit (L, mL, µL) per field. The calculator converts everything internally and returns the answer in the unit you picked for the blank field.`)
};

const es_soldil_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Elige cualquier unidad de concentración (M, mM, µM, nM) y de volumen (L, mL, µL) por campo. La calculadora convierte todo internamente y devuelve el resultado en la unidad que elegiste para el campo en blanco.`)
};

const de_soldil_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Wählen Sie pro Feld eine beliebige Konzentrationseinheit (M, mM, µM, nM) und Volumeneinheit (L, mL, µL). Der Rechner rechnet intern alles um und gibt das Ergebnis in der für das leere Feld gewählten Einheit aus.`)
};

const nl_soldil_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Kies per veld een willekeurige concentratie-eenheid (M, mM, µM, nM) en volume-eenheid (L, mL, µL). De calculator rekent alles intern om en geeft het antwoord in de eenheid die je voor het lege veld hebt gekozen.`)
};

const fr_soldil_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Choisissez n'importe quelle unité de concentration (M, mM, µM, nM) et de volume (L, mL, µL) par champ. Le calculateur convertit tout en interne et renvoie le résultat dans l'unité choisie pour le champ vide.`)
};

const it_soldil_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Scegli qualsiasi unità di concentrazione (M, mM, µM, nM) e di volume (L, mL, µL) per ciascun campo. Il calcolatore converte tutto internamente e restituisce il risultato nell'unità scelta per il campo vuoto.`)
};

const pt_br2_soldil_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Escolha qualquer unidade de concentração (M, mM, µM, nM) e de volume (L, mL, µL) por campo. A calculadora converte tudo internamente e retorna a resposta na unidade escolhida para o campo em branco.`)
};

const pt_soldil_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Escolha qualquer unidade de concentração (M, mM, µM, nM) e de volume (L, mL, µL) por campo. A calculadora converte tudo internamente e devolve o resultado na unidade escolhida para o campo em branco.`)
};

const ja_soldil_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。各フィールドで任意の濃度単位 (M, mM, µM, nM) と体積単位 (L, mL, µL) を選択できます。計算ツールが内部ですべて変換し、空欄フィールドに選んだ単位で答えを返します。`)
};

const zh_soldil_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。每个字段可任选浓度单位（M、mM、µM、nM）和体积单位（L、mL、µL）。计算器会在内部完成所有换算，并以你为空白字段选择的单位返回结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_faq_a2", locale)
	if (locale === "en") return en_soldil_faq_a2(inputs)
	if (locale === "es") return es_soldil_faq_a2(inputs)
	if (locale === "de") return de_soldil_faq_a2(inputs)
	if (locale === "nl") return nl_soldil_faq_a2(inputs)
	if (locale === "fr") return fr_soldil_faq_a2(inputs)
	if (locale === "it") return it_soldil_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_faq_a2(inputs)
	if (locale === "pt") return pt_soldil_faq_a2(inputs)
	if (locale === "ja") return ja_soldil_faq_a2(inputs)
	return zh_soldil_faq_a2(inputs)
};